import "./style.scss";

import MaintenanceScreen from "components/MaintenanceScreen";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

export type MaintenancePreviewContent = {
    startsAt: string;
    endsAt: string;
    title: string;
    description: string;
};

type Props = {
    preview: MaintenancePreviewContent;
    onClose: () => void;
};

const MaintenancePreview = ({ preview, onClose }: Props) => {
    const { t } = useTranslation();

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [onClose]);

    return createPortal(
        <div className="maintenance-preview">
            <div className="maintenance-preview-bar">
                <span>{t("AdminPanel.MaintenancePreviewHint")}</span>
                <button type="button" className="maintenance-preview-exit" onClick={onClose}>
                    {t("AdminPanel.MaintenancePreviewExit")}
                </button>
            </div>
            <MaintenanceScreen
                startsAt={preview.startsAt}
                endsAt={preview.endsAt}
                title={preview.title}
                description={preview.description}
                onRefresh={onClose}
            />
        </div>,
        document.body,
    );
};

export default MaintenancePreview;
